import { useCallback, useMemo, useReducer, } from 'react'

const initialState = {
  open: false,
  type: 'info',
  content: null,
};

const reducer = (state, { type, payload }) => {
  switch (type) {
    case 'openPopup':
      return {
        ...state,
        ...payload,
        open: true
      };
    case 'closePopup':
      return {
        ...state,
        ...initialState
      };
    default:
      return state;
  }
}


const useBehavior = () => {
  const [state, dispatch] = useReducer(reducer, initialState)


  const handleOpenPopup = useCallback((type) => (
    content => dispatch({ type: 'openPopup', payload: { content, type } })
  ), [dispatch]);

  const handleClose = useCallback(
    () => dispatch({ type: 'closePopup' }),
    [dispatch]
  );

  const actions = useMemo(() => ({
    popupSuccess: handleOpenPopup('success'),
    popupInfo: handleOpenPopup('info'),
    popupError: handleOpenPopup('error'),
  }), [handleOpenPopup]);

  return {
    ...state,
    ...actions,
    handleClose,
  }
}

export default useBehavior
